import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

/** UTILS || SLICE */
import { treatment } from 'app/slice/treatment.slice'

/** TYPES */
import { ModalCustomProps } from '../types/types'
import { usePaymentDataLoader } from './usePaymentDataLoader'


export const useIndex = (props: ModalCustomProps) => {

    const treatments = useSelector(treatment)

    // Use Data Loader Hook
    const {
        patientFinance,
        banks,
        billPrefixes,
        defaultPaymentChannels,
        promotionList,
        voucherList,
        loadData
    } = usePaymentDataLoader({
        ...props,
        treatments
    })

    // Load Data Effect
    useEffect(() => {
        if (props.isShow) {
            loadData()
        }  
    }, [props.isShow, loadData])

    // ✅ OPTIMIZED: Memoized bank arrays
    const bankTransfers = useMemo(() => [...banks.filter((bank: any) => bank.hasTransfer === 'SUPPORT')], [banks])
    const bankCredits = useMemo(() => [...banks.filter((bank: any) => bank.hasCredit === 'SUPPORT')], [banks])
    const bankDebits = useMemo(() => [...banks.filter((bank: any) => bank.hasDebit === 'SUPPORT')], [banks])

    return {
        listOrder: treatments?.summeryTreatments || [],
        defaultPaymentChannels,
        patientFinance,
        bankTransfers,
        bankCredits,
        bankDebits,
        billPrefixes,
        promotionList,
        voucherList, 
    }
}
